import { Country } from '~/Api/Country';

import Record, { StoryType } from './Record';
import Sentence, { MaybePart } from './Sentence';
import VirtualBrand from './VirtualBrand';

export interface RawRecord {
	storyType: string;
	yearMonth: string;
	country: { name: string; alpha2: string };
	virtualBrand: { id: string; name: string };
	summary: { parts: MaybePart[] };
	context: { parts: MaybePart[]; date: string }[];
}

export default function mapRecord(record: RawRecord): Record {
	return new Record(
		record.storyType as StoryType,
		new Date(record.yearMonth),
		new Country(record.country.alpha2, record.country.name),
		new VirtualBrand(record.virtualBrand.id, record.virtualBrand.name),
		new Sentence(record.summary.parts, null),
		record.context.map((sentence) => new Sentence(sentence.parts, new Date(sentence.date)))
	);
}
